import { Component, Input, Pipe, SecurityContext } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SocialLinksComponent } from '../social-links/social-links.component';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'sl-footer-columns',
  standalone: true,
  imports: [MatIconModule, NgFor, NgIf],
  templateUrl: './footer-columns.component.html',
  styleUrl:'./footer-columns.component.scss'
})
export class FooterColumnsComponent {

    constructor(
        private _domSanitizer: DomSanitizer,
    ){}

@Input() data:any;


sanitize(content:string){
    return this._domSanitizer.bypassSecurityTrustHtml(content)
}




}
